/**
 * b2b-min-order-checkout.js
 *
 * Keeps the checkout button disabled/enabled state in sync after AJAX cart
 * updates. The theme's swapInNewContent() only replaces .cart--body,
 * .cart--shipping, and .cart--totals — the checkout button is never
 * re-rendered on quantity changes. This module re-evaluates the button
 * whenever the theme fires "theme:cart:updated".
 *
 * Perf: /cart/change.js already returns the full cart object (including
 * total_price) but the theme only uses items/item_count/sections. We
 * intercept that response to cache total_price so the theme:cart:updated
 * handler can use it directly without firing a separate /cart.js request.
 * A /cart.js fallback is kept for cart-add flows where /cart/add.js does
 * not include total_price.
 */

(function () {
  let _cachedCartTotal = null;

  // Intercept /cart/change.js responses to cache total_price.
  // This script runs after b2b-cart-quantity-error.js, so window.fetch is
  // already patched once — we just wrap it again.
  const _originalFetch = window.fetch;
  window.fetch = async function (resource, options) {
    const response = await _originalFetch.apply(this, arguments);
    const urlStr = typeof resource === 'string' ? resource : resource?.url ?? '';
    if (response.ok && urlStr.includes('/cart/change')) {
      try {
        const data = await response.clone().json();
        if (typeof data.total_price === 'number') {
          _cachedCartTotal = data.total_price;
        }
      } catch {
        // ignore — fallback to /cart.js will handle it
      }
    }
    return response;
  };

  function updateCheckoutButtons(cartTotalCents) {
    document.querySelectorAll('.cart--checkout-button[data-min-order-cents]').forEach((btn) => {
      const minCents = parseInt(btn.dataset.minOrderCents, 10);
      const below = cartTotalCents < minCents;
      const textEl = btn.querySelector('.cart-button--text');

      if (below) {
        const label = btn.dataset.minOrderLabel || btn.dataset.checkoutLabel || 'Checkout';
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-min-order-disabled', 'true');
        btn.dataset.text = label;
        if (textEl) textEl.textContent = label;
      } else {
        const label = btn.dataset.checkoutLabel || 'Checkout';
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-min-order-disabled');
        btn.dataset.text = label;
        if (textEl) textEl.textContent = label;
      }
    });
  }

  let _debounceTimer = null;
  window.addEventListener('theme:cart:updated', () => {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(() => {
      if (_cachedCartTotal !== null) {
        const total = _cachedCartTotal;
        _cachedCartTotal = null;
        updateCheckoutButtons(total);
        return;
      }
      // Fallback for cart-add flows (POST /cart/add.js does not return total_price)
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => updateCheckoutButtons(cart.total_price))
        .catch(() => {});
    }, 80);
  });
})();
